import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

const querySlice = createReduxSlice<{ [key: string]: { hash: string; value: any } }>('query')

export const getQuery = <T>(
  key: string,
  {
    hash,
    init,
  }: {
    hash: string
    init: (signal: AbortSignal) => Promise<T>
  }
) =>
  createThunk((dispatch, _getState, context): Promise<T> => {
    const queryContext = context.getOrInsert(querySymbol, () => ({}))
    const current = queryContext[key]
    if (current) {
      if (current.hash === hash) {
        return current.value
      }
      current.ab.abort()
      delete queryContext[key]
    }

    const abortController = new AbortController()

    const map = dispatch(querySlice.get()) ?? {}
    const mapVal = map[key]
    if (mapVal && mapVal.hash === hash) {
      const p = Promise.resolve(mapVal.value)
      queryContext[key] = { hash, value: p, ab: abortController }
      return p
    }

    // A failure stays under its hash: a render retrying `use` must get this same rejection, or every
    // retry starts a request of its own. A new hash asks again.
    const p = init(abortController.signal).then(v => {
      if (!abortController.signal.aborted) {
        dispatch(querySlice.update(state => ({ ...state, [key]: { hash, value: v } })))
      }
      return v
    })

    queryContext[key] = { hash, value: p, ab: abortController }
    return p
  })

const querySymbol = Symbol('query')
